import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import TooltipModalBody from "ds/components/TooltipModal/Body";
import { TooltipModalTitle } from "ds/components/TooltipModal/Title";
import { getDocsUrl } from "utils/getDocsUrl";

const FormFieldAccessibleProjectsTooltip = () => (
  <>
    <TooltipModalTitle>Accessible projects</TooltipModalTitle>
    <TooltipModalBody align="start">
      When configured, only the specified Azure DevOps projects will be accessible to this
      integration. If left empty, all projects in the organization will be accessible.
      <ReadMoreDocsLink docsUrl={getDocsUrl("/integrations/source-control/azure-devops.html")} />
    </TooltipModalBody>
  </>
);

export default FormFieldAccessibleProjectsTooltip;
